//* fetch all data from a specific table
export const fetchDataList = async (table) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}`).then((res) =>
    res.json()
  );
};

//* fetch data from specific table row
export const fetchData = async (table, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}/${id}`).then((res) =>
    res.json()
  );
};

//* fetch data from specific table category
export const fetchCategoryData = async (table, category, id) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}/${category}/${id}`
  ).then((res) => res.json());
};

//* fetch limited data from specific table
export const fetchFilterData = async (table, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?offset=${
      page * length
    }&length=${length}`
  ).then((res) => res.json());
};

//* fetch limited data from specific company
export const fetchCompanyDataList = async (table, id, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}/${id}?offset=${
      page * length
    }&length=${length}`
  ).then((res) => res.json());
};

//* fetch limited data from specific category
export const fetchSubjectData = async (table, id, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}/${id}?offset=${
      page * length
    }&length=${length}`
  ).then((res) => res.json());
};

//* fetch data length from specific category
export const fetchSubjectLength = async (table, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}?category=${id}`).then(
    (res) => res.json()
  );
};

//* fetch limited data from matching elements of search
export const fetchSearchData = async (table, value, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?value=${value}&offset=${
      page * length
    }&length=${length}`
  ).then((res) => res.json());
};

//* fetch data length from matching elements of search
export const fetchSearchLength = async (table, value) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?search=${value}`
  ).then((res) => res.json());
};

//* send email
export const sendEmail = async (email, subject, message) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/email/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      subject,
      message,
    }),
  });

  if (!response.ok) {
    throw new Error("Error while sending email");
  }

  return response.json();
};

//* fetch data length from table
export const fetchDataLength = async (table) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}`).then((res) =>
    res.json()
  );
};

//* fetch limited data from table
export const fetchLimitedData = async (table, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?offset=${
      page * length
    }&length=${length}`
  ).then((res) => res.json());
};

//* calculate compound interest
export const calculateCompoundInterest = async (
  capital,
  saving,
  interest,
  duration,
  interval
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/compoundinterest?capital=${capital}&saving=${saving}&interest=${interest}&duration=${duration}&interval=${interval}`
  ).then((res) => res.json());
};

//* calculate cashflow
export const calculateCashflow = async (params) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/cashflow?parameters=${params}`
  ).then((res) => res.json());
};

//* calculate roi
export const calculateROI = async (
  investment,
  amount,
  percentage,
  dividendYield,
  increaseDividend
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/roi?investment=${investment}&amount=${amount}&increasePercentage=${percentage}&dividendYield=${dividendYield}&increaseDividend=${increaseDividend}`
  ).then((res) => res.json());
};

//* calculate inflation
export const calculateInflation = async (amount, inflationRate, duration) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/inflation?amount=${amount}&inflation=${inflationRate}&duration=${duration}`
  ).then((res) => res.json());
};
